import React from "react"
import { Form, RadioGroup, Radio } from "rsuite";

function YesNoRadioOption(props) {
    return (
        <Form.Group controlId="formBasicCheckbox">
            <Form.ControlLabel className="d-none">Yes/No Radio Buttons</Form.ControlLabel>
            <Form.Control
                plaintext={props.plaintext}
                readOnly={props.isReadOnly}
                name={props.radioName}
                inline
                onChange={props.handleChange}
                accepter={RadioGroup}>
                <Radio value={true}>Yes</Radio>
                <Radio value={false}>No</Radio>
            </Form.Control>
            <Form.HelpText className="d-none"></Form.HelpText>
        </Form.Group>
    );
}

export default YesNoRadioOption